/**
 * Utilities for Firebase Realtime Database path and key operations.
 */

/**
 * Sanitizes a string so that it can be safely used as a Firebase Realtime Database path segment / key.
 * Firebase keys cannot contain '.', '#', '$', '/', '[', ']', or ASCII control characters (0-31 and 127),
 * and cannot exceed 768 bytes UTF-8.
 */
export function sanitizeFirebaseKey(key: string): string {
  if (!key || typeof key !== 'string') return '';
  const sanitized = key
    .replace(/[.#$\[\]/\x00-\x1f\x7f]/g, '_')
    .trim();
  return sanitized.length > 500 ? sanitized.slice(0, 500) : sanitized;
}
